<script setup lang="ts">
/**
 * PublicLayout - layout для публичных маркетинговых страниц.
 * Header (sticky) + Content (со скроллом) + Footer.
 */
import ThePublicHeader from './ThePublicHeader.vue'
import ThePublicFooter from './ThePublicFooter.vue'
</script>

<template>
  <div class="min-h-screen flex flex-col bg-base-100">
    <ThePublicHeader />

    <!-- Контент страницы (pt-16 для отступа под fixed header) -->
    <main class="flex-1 pt-16">
      <RouterView v-slot="{ Component }">
        <Transition
          name="page"
          mode="out-in"
        >
          <component :is="Component" />
        </Transition>
      </RouterView>
    </main>

    <ThePublicFooter />
  </div>
</template>

<style scoped>
.page-enter-active,
.page-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.page-enter-from {
  opacity: 0;
  transform: translateY(4px);
}
.page-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
